/* eslint-disable no-lonely-if */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import UnauthorizedAccess from "./UnauthorizedAccess";
import usePermission, {
  useSongaTenant,
  useTenantPermission,
} from "../hooks/usePermission";

const ProtectedRoute = ({
  component,
  allowedPermissions = [],
  allowedTenantPermissions = [],
  songaSpecificPermission = false,
}) => {
  const navigate = useNavigate();

  const hasPermission = usePermission(allowedPermissions);
  const hasTenantPermission = useTenantPermission(allowedTenantPermissions);
  const isSongaTenantUser = useSongaTenant();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/");
      return;
    }

    const decodedToken = jwtDecode(token);
    const expirationTime = new Date(decodedToken.exp);
    const currentTime = new Date();

    const isValid = expirationTime * 1000 > currentTime.getTime();

    if (!isValid) navigate("/");
  }, [navigate]);

  if (allowedTenantPermissions.length > 0 && !hasTenantPermission) {
    return <UnauthorizedAccess />;
  }

  if (songaSpecificPermission) {
    if (!isSongaTenantUser) {
      return <UnauthorizedAccess />;
    }
  } else {
    if (!hasPermission) {
      return <UnauthorizedAccess />;
    }
  }

  return component;
};

export default ProtectedRoute;
